import { render, staticRenderFns } from "./workscoreList.vue?vue&type=template&id=ed9bc316&scoped=true"
import script from "./workscoreList.vue?vue&type=script&lang=js"
export * from "./workscoreList.vue?vue&type=script&lang=js"
import style0 from "./workscoreList.vue?vue&type=style&index=0&id=ed9bc316&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9bc316",
  null
  
)

export default component.exports